import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "urgent"
}
const _hoisted_2 = { class: "lines" }
const _hoisted_3 = { class: "times" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "ticket" }
const _hoisted_6 = { class: "foot" }

import {computed,onBeforeUnmount,ref,watch} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import {activityBrowsePaths,createActivityVisit,validWebActivity,activityCouponTarget} from '@/utils/activityCoupon'

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityCoupon',
  props: {
    ready: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {ready:boolean};

const route=useRoute(),router=useRouter()
const visible=ref(false),config=ref<any>({}),visit=createActivityVisit()
let serial=0,timer:ReturnType<typeof setTimeout>|undefined
const scope=computed(()=>props.ready && Number(store.getters.orgInfo?.id)===Number(store.getters.orgId)?Number(store.getters.orgId):0)
const allowed=computed(()=>scope.value>=1000 && activityBrowsePaths.has(route.path) && document.visibilityState!=='hidden')
const urgent=computed(()=>config.value.endTime-Date.now()<=config.value.urgentHours*3600000)
const format=(v:number)=>v?new Date(v).toLocaleString('zh-CN',{hour12:false}):''
const close=()=>{visible.value=false;clearTimeout(timer)}
async function check(){
  const current=++serial,orgId=scope.value;close();if(!allowed.value)return
  try{
    const response=await request({url:'fsystem/activityCoupon',method:'GET',params:{orgId}}),value=response.data
    if(current!==serial || orgId!==scope.value || !allowed.value || Number(value?.orgId)!==orgId || !validWebActivity(value))return
    if(!visit.claim(orgId+':'+value.templateId+':'+value.startTime))return
    config.value=value;visible.value=true;timer=setTimeout(close,value.popupSeconds*1000)
  }catch{/* 活动失败不阻止浏览，不回落到其他机构活动。 */}
}
async function viewCoupons(){
  close()
  if(config.value.mode==='coupon'){
    const target=activityCouponTarget(config.value,scope.value);if(!target)return
    await router.push({path:'/main/cuscenter/notes',query:{activityCouponId:String(target.couponId),activityOrgId:String(target.orgId)}})
    if(!store.getters.token || !store.getters.userInfo?.id || Number(store.getters.userInfo.orgId)!==target.orgId)store.state.user.loginCallback?.()
    return
  }
  if(!store.getters.token || !store.getters.userInfo?.id){void router.push('/prelogin');return}
  void router.push('/main/cuscenter/notes')
}
watch(()=>[scope.value,allowed.value],()=>{void check()},{immediate:true})
function visibility(){serial++;close();if(document.visibilityState!=='hidden'){visit.begin();void check()}}
document.addEventListener('visibilitychange',visibility)
onBeforeUnmount(()=>{serial++;close();document.removeEventListener('visibilitychange',visibility)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    footer: null,
    closable: false,
    "mask-closable": false,
    width: 390,
    "wrap-class-name": "client-activity-shell",
    "body-style": {padding:'0',background:'transparent'},
    onCancel: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(['client-activity',config.value.base])
      }, [
        (_unref(urgent))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(config.value.urgentText), 1))
          : _createCommentVNode("", true),
        _createElementVNode("small", null, _toDisplayString(config.value.eyebrow), 1),
        _createElementVNode("h2", null, _toDisplayString(config.value.title), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString((config.value.lines || []).join('\n')), 1),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(config.value.startLabel) + " " + _toDisplayString(format(config.value.startTime)), 1),
          _hoisted_4,
          _createTextVNode(_toDisplayString(config.value.endLabel) + " " + _toDisplayString(format(config.value.endTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(config.value.amount), 1),
            _createElementVNode("small", null, _toDisplayString(config.value.threshold), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("b", null, _toDisplayString(config.value.couponTitle), 1),
            _createElementVNode("small", null, _toDisplayString(config.value.scope), 1)
          ])
        ]),
        _createElementVNode("button", {
          class: "cta",
          type: "button",
          onClick: viewCoupons
        }, _toDisplayString(config.value.buttonText), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(config.value.footnote), 1)
      ], 2),
      _createElementVNode("button", {
        class: "activity-close",
        type: "button",
        "aria-label": "关闭活动弹窗",
        onClick: close
      }, "×")
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})